import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'schools/v4';
}
